// sections-2.jsx — extraído de index.html el 2026-08-28 (Etapa 1, Bloque C).
//
// Hasta hoy este código vivía incrustado en index.html dentro de un
// <script type="text/babel"> que @babel/standalone compilaba en el navegador de
// cada visitante. El atributo data-source lo atribuía a «NUEVA WEB/sections-2.jsx»,
// una carpeta que no existe en el repositorio ni en el disco: el bloque incrustado
// era la única fuente de verdad (hallazgo H5 del inventario).
//
// El contenido es copia EXACTA del bloque original. No se reformateó ni se
// renombró nada: se compila con las mismas opciones que aplicaba el CDN y la
// salida debe ser byte a byte la misma. Ver scripts/build-jsx.mjs.
//
// Se carga como script clásico, NO como módulo: las declaraciones de nivel
// superior son globales y las otras entradas del home las leen por nombre.

/* global React */
(() => {

// ============================================================
// DIRECTORY — real hotspot data with map + category filters
// ============================================================

const DIR_REGIONS = [
  { id: 'CR', label: 'Costa Rica' },
  { id: 'PJ', label: 'Jacó Beach' },
  { id: 'TA', label: 'Tamarindo' },
  { id: 'FA', label: 'Arenal & La Fortuna' },
  { id: 'MA', label: 'Manuel Antonio & Quepos' },
  { id: 'CH', label: 'Playas del Coco & Hermosa' },
  { id: 'DU', label: 'Costa Ballena' },
  { id: 'HE', label: 'Herradura Beach' },
];

const DIR_CAT_DEFS = [
  { id: 'all',          icon: 'general_icon.png' },
  { id: 'accom',        icon: 'accomodation_icom.png' },
  { id: 'rest',         icon: 'restaurante_icon.png' },
  { id: 'tour',         icon: 'transport_icon.png' },
  { id: 'shop',         icon: 'shopping_icon.png' },
  { id: 'poi-beach',    icon: 'beach_icon.png' },
  { id: 'poi-park',     icon: 'park_icon.png' },
  { id: 'poi-monument', icon: 'monument_icon.png' },
  { id: 'poi-museum',   icon: 'museum_icon.png' },
  { id: 'poi-hospital', icon: 'hospital_icom.png' },
  { id: 'poi-police',   icon: 'police_icon.png' },
  { id: 'poi-atm',      icon: 'atm_icon.png' },
  { id: 'poi-info',     icon: 'info_icon.png' },
  { id: 'poi-church',   icon: 'church_icon.png' },
];

const DIR_CAT_ICON = {
  accom: 'accomodation_icom.png', rest: 'restaurante_icon.png',
  tour: 'transport_icon.png', shop: 'shopping_icon.png',
  'poi-beach': 'beach_icon.png', 'poi-park': 'park_icon.png',
  'poi-hospital': 'hospital_icom.png', 'poi-police': 'police_icon.png',
  'poi-atm': 'atm_icon.png', 'poi-info': 'info_icon.png',
  'poi-monument': 'monument_icon.png', 'poi-museum': 'museum_icon.png',
  'poi-church': 'church_icon.png', 'poi-general': 'general_icon.png',
  'poi-promo': 'nav_icon.png', default: 'general_icon.png',
};

function _dirFV(v) { return Array.isArray(v) ? (v[0] ?? '') : (v ?? ''); }

function _dirCatKey(r) {
  const rawPoi = String(_dirFV(r.poiCategory) || '').trim().toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const aliases = {
    hospital: 'hospital', clinic: 'hospital', policia: 'police', police: 'police',
    cajero: 'atm', banco: 'atm', atm: 'atm', parque: 'park', atraccion: 'park', park: 'park',
    playa: 'beach', playas: 'beach', beach: 'beach', info: 'info',
    monument: 'monument', monumento: 'monument', museo: 'museum', museum: 'museum',
    general: 'general', iglesia: 'church', church: 'church',
    promo: 'promo', promocion: 'promo', link: 'promo',
  };
  const poi = aliases[rawPoi];
  if (poi) return `poi-${poi}`;
  const isAct = v => { const s = String(_dirFV(v) || '').trim().toUpperCase(); return s === '1' || s === 'TRUE' || s === 'SI'; };
  if (isAct(r.Accom)) return 'accom';
  if (isAct(r.Rest)) return 'rest';
  if (isAct(r.Tour)) return 'tour';
  if (isAct(r.Shop)) return 'shop';
  return 'default';
}

function _dirSafeStr(raw) {
  const v = String(_dirFV(raw) || '').trim();
  return (!v || /^[.\-]$/.test(v) || /^N\/?A$/i.test(v)) ? '' : v;
}

function _dirSafeUrl(raw) {
  const v = _dirSafeStr(raw);
  if (!v) return '';
  return /^https?:\/\//i.test(v) ? v : `https://${v}`;
}

// Published ficha (api/hotspots adds `placeUrls`): only our own place paths.
function _dirPlaceUrls(value) {
  if (!value || typeof value !== 'object') return null;
  const es = String(value.es || '');
  const en = String(value.en || '');
  const ok = (path, prefix) => path.startsWith(prefix) && /^\/[a-z0-9._~%\/-]+\/$/i.test(path) && !path.includes('//');
  return ok(es, '/es/lugar/') && ok(en, '/en/place/') ? { es, en } : null;
}

// «Descubre este lugar»: link to the place's public ficha, under the actions.
function DirPlaceButton({ url, copy, onOpen }) {
  return (
    <a className="dir-place-btn" href={url} onClick={onOpen}>
      <span className="dir-place-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/></svg>
      </span>
      <span className="dir-place-text">
        <span className="dir-place-title">{copy.title}</span>
        <span className="dir-place-sub">{copy.subtitle}</span>
      </span>
      <span className="dir-place-chev" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 6 6 6-6 6"/></svg>
      </span>
    </a>
  );
}

function _dirSafeEmail(raw) {
  const v = String(_dirFV(raw) || '').trim().replace(/\s+/g, '');
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? v : '';
}

function _dirSanitizeDesc(rawHtml) {
  const original = String(rawHtml ?? '');
  if (!original.trim()) return '';
  if (typeof DOMParser === 'undefined') return original.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\r?\n/g,'<br>');
  const hasMarkup = /<[^>]+>/.test(original);
  if (!hasMarkup) return original.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\r?\n/g,'<br>');
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${original}</div>`, 'text/html');
  const wrapper = doc.body.firstElementChild;
  if (!wrapper) return '';
  const allowed = new Set(['B','STRONG','I','EM','U','S','BR','P','DIV','UL','OL','LI','A','BLOCKQUOTE','PRE']);
  const safeHref = /^(https?:|mailto:|tel:)/i;
  const walk = node => {
    if (node.nodeType === 3) return doc.createTextNode(node.textContent || '');
    if (node.nodeType !== 1) return null;
    const tag = node.tagName.toUpperCase();
    if (['SCRIPT','STYLE','IFRAME','OBJECT','EMBED'].includes(tag)) return null;
    if (!allowed.has(tag)) {
      const frag = doc.createDocumentFragment();
      node.childNodes.forEach(c => { const s = walk(c); if (s) frag.appendChild(s); });
      return frag;
    }
    const el = doc.createElement(tag === 'DIV' ? 'p' : tag.toLowerCase());
    if (tag === 'A') { const h = String(node.getAttribute('href')||'').trim(); if (h && safeHref.test(h)) { el.setAttribute('href',h); el.setAttribute('target','_blank'); el.setAttribute('rel','noopener noreferrer'); } }
    node.childNodes.forEach(c => { const s = walk(c); if (s) el.appendChild(s); });
    if (tag === 'A' && !el.getAttribute('href')) { const frag = doc.createDocumentFragment(); while(el.firstChild) frag.appendChild(el.firstChild); return frag; }
    return el;
  };
  const out = doc.createElement('div');
  wrapper.childNodes.forEach(c => { const s = walk(c); if (s) out.appendChild(s); });
  return out.innerHTML.replace(/ /g,' ');
}

// OSM location map in the directory side panel: hidden for now (replaced by the
// DZI mini map). Kept as a flag, not deleted, until we decide whether to drop
// it or keep it as an additional "real-world" map. Flip to true to show it again.
const _DIR_SHOW_OSM_FALLBACK = true;

// Side-panel DZI mini map: opens a hotspot-free viewer centered (with a
// zoom-in animation) on the client's position on OUR map, from the coordinate
// generator (xy). Only instantiates when its container is actually visible, so
// the desktop and mobile panels never spin up two viewers at once.
function DirMiniMap({ mapCode, xy, recordId }) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const el = ref.current;
    if (!el || !window.CRMapsDirMiniMap || !mapCode || !xy) return;
    if (el.offsetParent === null) return; // hidden panel → let the visible one handle it
    const handle = window.CRMapsDirMiniMap.open(el, { mapCode, xy });
    return () => { try { handle && handle.destroy(); } catch (e) {} };
  }, [mapCode, xy, recordId]);
  return React.createElement('div', { ref, className: 'dir-panel-map-dzi', 'aria-label': 'Ubicación en el mapa' });
}

function _dirAdaptRecord(record, mapaId) {
  const catKey = _dirCatKey(record);
  const icon = DIR_CAT_ICON[catKey] || DIR_CAT_ICON.default;
  const phone = _dirSafeStr(record.Tel1);
  const whatsapp = _dirSafeStr(record.whatsapp);
  const email = _dirSafeEmail(record.email || record.Email);
  const website = _dirSafeUrl(record.WebLink);
  const gmaps = _dirSafeUrl(record.GmapLink);
  const gps = String(_dirFV(record.GPS) || '').trim();
  let waze = '', gpsLat = null, gpsLon = null;
  if (gps) {
    const parts = gps.split(',');
    if (parts.length === 2 && parts.every(p => !isNaN(parseFloat(p.trim())))) {
      gpsLat = parseFloat(parts[0].trim());
      gpsLon = parseFloat(parts[1].trim());
      waze = `https://waze.com/ul?ll=${gpsLat},${gpsLon}&navigate=yes`;
    }
  }
  let hero = '';
  const artUrl = String(_dirFV(record.ArtworkUrl) || '').trim();
  if (artUrl && /^https?:\/\//i.test(artUrl)) {
    const own = artUrl.replace(/^https?:\/\/(www\.)?(staging\.crmaps\.com|crmaps\.com|localhost)(:\d+)?(?=\/|$)/i, '');
    hero = own || artUrl;
  } else {
    const artFile = String(_dirFV(record.Artwork) || '').trim();
    if (artFile && artFile !== '--' && artFile !== '.' && !artFile.includes('/') && /\.(jpe?g|png|webp|gif|avif)$/i.test(artFile)) {
      hero = `/imagenes/ads/${encodeURIComponent(artFile)}`;
    }
  }
  const baseId = String(_dirFV(record.ClientID) || _dirFV(record.id) || '');
  const dupId = String(_dirFV(record.__duplicateId) || '').trim();
  const desc = String(_dirFV(record.description) || '').trim();
  return {
    id: dupId ? `${baseId}::dup::${dupId}` : baseId,
    name: String(_dirFV(record.Company) || ''),
    icon, hero, desc, phone, whatsapp, email, website, gmaps, waze, gpsLat, gpsLon,
    _catKey: catKey, _mapaId: mapaId,
    placeUrls: _dirPlaceUrls(record.placeUrls),
    // Position on OUR tourist map, from the CRMAPS coordinate generator
    // (center-offset). Drives the side-panel DZI mini map. Not GPS.
    xy: String(_dirFV(record.xy) || '').trim(),
  };
}

async function _loadDirRegion(regionId) {
  const code = String(regionId || '').trim().toUpperCase();
  if (!code) return [];
  try {
    const res = await fetch(`/api/hotspots/${code}.json?_=${Math.floor(Date.now() / 300000)}`, { cache: 'no-store' });
    if (!res.ok) return [];
    const payload = await res.json();
    const records = Array.isArray(payload) ? payload
      : (payload && typeof payload === 'object' && !payload.error ? Object.values(payload) : []);
    const valid = records.filter(r => r && typeof r === 'object' && !Array.isArray(r));
    return valid.map(r => _dirAdaptRecord(r, regionId));
  } catch { return []; }
}

// Back from a place ficha that rebuilt the page (no back/forward cache): how
// the directory looked when the visitor left, which openPlace leaves on the
// history entry. Only on a back/forward load.
function _dirReturnState() {
  let saved = null;
  try {
    const navigation = performance.getEntriesByType('navigation')[0];
    saved = navigation && navigation.type === 'back_forward' && history.state && history.state.crmapsReturnDir;
  } catch (err) {}
  if (!saved || typeof saved !== 'object') return null;
  const str = (v) => (typeof v === 'string' ? v : '');
  return {
    map: DIR_REGIONS.some(r => r.id === saved.map) ? saved.map : 'all',
    cat: DIR_CAT_DEFS.some(c => c.id === saved.cat) ? saved.cat : 'all',
    search: str(saved.search),
    key: str(saved.key),
    listTop: Math.max(0, Number(saved.listTop) || 0),
  };
}

// Taken once, so the entry's next visit starts as usual.
function _dirForgetReturn() {
  try {
    const state = history.state;
    if (!state || typeof state !== 'object' || !state.crmapsReturnDir) return;
    const { crmapsReturnDir, ...rest } = state;
    history.replaceState(rest, '');
  } catch (err) {}
}

function DirectorySection({ copy, lang }) {
  const [dirReturn] = React.useState(_dirReturnState);
  const [allHotspots, setAllHotspots] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [fetched, setFetched] = React.useState(false);
  const [selectedMap, setSelectedMap] = React.useState(() => (dirReturn ? dirReturn.map : 'all'));
  const [catFilter, setCatFilter] = React.useState(() => (dirReturn ? dirReturn.cat : 'all'));
  const [selected, setSelected] = React.useState(null);
  const [mapOpen, setMapOpen] = React.useState(false);
  const [catOpen, setCatOpen] = React.useState(false);
  const [search, setSearch] = React.useState(() => (dirReturn ? dirReturn.search : ''));
  const [showMore, setShowMore] = React.useState(false);
  const [panelOpen, setPanelOpen] = React.useState(false);
  const sectionRef = React.useRef(null);
  const listWrapRef = React.useRef(null);
  const panelRef = React.useRef(null);
  const hintRef = React.useRef(null);
  const hintDismissedRef = React.useRef(false);
  const mobilePanelRef = React.useRef(null);
  const dc = copy.directory;
  const catLabels = dc.catLabels;

  const placeUrl = (selected && selected.placeUrls && selected.placeUrls[lang === 'es' ? 'es' : 'en']) || '';

  // Close the mobile panel first, so Back from the ficha (its arrow or the
  // browser's) lands on the directory with nothing covering it. The desktop
  // detail column is not a popup: it keeps the place selected. Back may also
  // rebuild the page instead of restoring it from the back/forward cache, so
  // the filters, the selected place and the list position are left on the
  // history entry for _dirReturnState.
  function openPlace(e) {
    trackDir('ficha');
    // Ctrl/Cmd/Shift/middle click: new tab, the panel stays as it is.
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    setPanelOpen(false);
    // The pointer is on the detail panel, which holds the page still while it
    // is there (desktop lock below). If Back restores this page from the cache,
    // nothing releases it until the pointer moves: release it on the way out.
    document.body.style.overflow = '';
    try {
      const state = history.state && typeof history.state === 'object' ? history.state : {};
      history.replaceState({ ...state, crmapsReturnDir: {
        map: selectedMap, cat: catFilter, search, key: selKey,
        listTop: Math.round(listWrapRef.current ? listWrapRef.current.scrollTop : 0),
      } }, '');
    } catch (err) {}
    window.location.assign(placeUrl);
  }

  function trackDir(action) {
    if (window.trackEvent && selected) {
      window.trackEvent({ type: 'action_click', company: selected.name, clientId: selected.id || '', mapCode: selected._mapaId || '', action });
    }
  }

  React.useEffect(() => {
    if (fetched) return;
    setFetched(true);
    setLoading(true);
    Promise.all(DIR_REGIONS.map(r => _loadDirRegion(r.id))).then(results => {
      const flat = results.flat().filter(h => h._catKey !== 'poi-promo' && h.name);
      // Dedup per map: same business can appear in DU and MA but not twice within the same map.
      const seen = new Set();
      const deduped = flat.filter(h => {
        const name = (h.name || '').trim().toLowerCase();
        const key = name + '\x00' + (h._mapaId || '');
        if (!name || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      setAllHotspots(deduped);
      const back = dirReturn && deduped.find(h => `${h._mapaId}:${h.id}` === dirReturn.key);
      if (back || deduped.length > 0) setSelected(back || deduped[0]);
      setLoading(false);
      deduped.forEach(h => { if (h.hero) { const i = new Image(); i.src = h.hero; } });
    });
  }, [fetched]);

  // The list is on screen now: put it back where it was, then forget it.
  React.useEffect(() => {
    if (!dirReturn || loading || allHotspots.length === 0) return;
    if (listWrapRef.current) listWrapRef.current.scrollTop = dirReturn.listTop;
    _dirForgetReturn();
  }, [allHotspots, loading]);

  // Restored from the back/forward cache instead: the page is as it was left.
  React.useEffect(() => {
    const onShow = (e) => { if (e.persisted) _dirForgetReturn(); };
    window.addEventListener('pageshow', onShow);
    return () => window.removeEventListener('pageshow', onShow);
  }, []);

  React.useEffect(() => {
    if (!mapOpen) return;
    const close = () => setMapOpen(false);
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [mapOpen]);

  React.useEffect(() => {
    if (!catOpen) return;
    const close = () => setCatOpen(false);
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [catOpen]);

  React.useEffect(() => {
    if (panelRef.current) panelRef.current.scrollTop = 0;
    if (mobilePanelRef.current) mobilePanelRef.current.scrollTop = 0;
    hintDismissedRef.current = false;
    setShowMore(false);
  }, [selected]);

  React.useEffect(() => {
    const panel = panelRef.current;
    if (!panel) return;
    const dismissed = hintDismissedRef.current;
    if (!dismissed) {
      const overflows = panel.scrollHeight - panel.clientHeight > 24;
      setShowMore(overflows);
    }
    const onScroll = () => {
      if (panel.scrollTop > 0 && !hintDismissedRef.current) {
        if (hintRef.current) hintRef.current.style.display = 'none';
        setShowMore(false);
        hintDismissedRef.current = true;
      }
    };
    const ro = new ResizeObserver(() => {
      if (hintDismissedRef.current) return;
      const overflows = panel.scrollHeight - panel.scrollTop - panel.clientHeight > 24;
      setShowMore(overflows);
    });
    panel.addEventListener('scroll', onScroll, { passive: true });
    ro.observe(panel);
    return () => { panel.removeEventListener('scroll', onScroll); ro.disconnect(); };
  }, [selected]);

  // Mobile: lock body scroll when the full-screen panel covers the page
  React.useEffect(() => {
    if (!(panelOpen && selected)) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, [panelOpen, selected]);

  // Desktop: lock body scroll only while mouse is over the panel so scroll-snap
  // can't steal the wheel event, but restores immediately when mouse leaves.
  React.useEffect(() => {
    const panel = panelRef.current;
    if (!panel) return;
    const lock   = () => { document.body.style.overflow = 'hidden'; };
    const unlock = () => { document.body.style.overflow = ''; };
    panel.addEventListener('mouseenter', lock);
    panel.addEventListener('mouseleave', unlock);
    return () => {
      panel.removeEventListener('mouseenter', lock);
      panel.removeEventListener('mouseleave', unlock);
      document.body.style.overflow = '';
    };
  }, []);

  // For "all maps" view deduplicate by name so same business shows once.
  // For a specific map, show every entry belonging to that map (already deduped within-map above).
  let afterMapFilter;
  if (selectedMap === 'all') {
    const seenNames = new Set();
    afterMapFilter = allHotspots.filter(h => {
      const name = (h.name || '').trim().toLowerCase();
      if (!name || seenNames.has(name)) return false;
      seenNames.add(name);
      return true;
    });
  } else {
    afterMapFilter = allHotspots.filter(h => h._mapaId === selectedMap);
  }

  const filtered = (catFilter === 'all' ? afterMapFilter : afterMapFilter.filter(h => h._catKey === catFilter))
    .filter(h => !search || h.name.toLowerCase().includes(search.toLowerCase()))
    .slice()
    .sort((a, b) => (a.name || '').localeCompare((b.name || ''), 'es', { sensitivity: 'base', numeric: true }));

  const activeCats = DIR_CAT_DEFS.filter(c =>
    c.id === 'all' || afterMapFilter.some(h => h._catKey === c.id)
  );

  const selectedMapLabel = selectedMap === 'all'
    ? dc.allMaps
    : (DIR_REGIONS.find(r => r.id === selectedMap)?.label || dc.allMaps);

  const selectedCatLabel = catFilter === 'all'
    ? dc.allCats
    : (catLabels[catFilter] || catFilter);

  const selectedCatDef = catFilter === 'all' ? null : DIR_CAT_DEFS.find(c => c.id === catFilter);

  const selKey = selected ? `${selected._mapaId}:${selected.id}` : null;

  return (
    <section ref={sectionRef} className="section section--paper" id="directory" data-screen-label="04 Directory">
      <div className="section-inner">
        <div className="reveal" style={{ textAlign: "center" }}>
          <span className="kicker" style={{ marginLeft: "auto", marginRight: "auto" }}>{dc.kicker}</span>
          <h2 className="title title--center">{dc.titleLine1}</h2>
          <p className="lede lede--center">{dc.lede}</p>
        </div>

        <div className="dir-layout" id="dir-grid">
          <div className="dir-left-col">
          <div className="dir-left">
            <div className="dir-controls reveal">
              <div style={{ position: "relative", flexShrink: 0 }}>
                <button className="dir-map-btn" onClick={e => { e.stopPropagation(); setMapOpen(o => !o); setCatOpen(false); }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>
                  {dc.btnMaps}
                  {selectedMap !== "all" && <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--cr-blue)", flexShrink: 0 }} />}
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ transform: mapOpen ? "rotate(180deg)" : "none", transition: "transform 0.15s" }}><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                {mapOpen && (
                  <div className="dir-map-dropdown" onMouseDown={e => e.stopPropagation()}>
                    <button className={`dir-map-item${selectedMap === "all" ? " is-on" : ""}`}
                      onClick={() => { setSelectedMap("all"); setCatFilter("all"); setMapOpen(false); }}>
                      {dc.allMaps}{selectedMap === "all" && <span>✓</span>}
                    </button>
                    {DIR_REGIONS.map(r => (
                      <button key={r.id} className={`dir-map-item${selectedMap === r.id ? " is-on" : ""}`}
                        onClick={() => { setSelectedMap(r.id); setCatFilter("all"); setMapOpen(false); }}>
                        {r.label}{selectedMap === r.id && <span>✓</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div style={{ position: "relative", flexShrink: 0 }}>
                <button className="dir-map-btn" onClick={e => { e.stopPropagation(); setCatOpen(o => !o); setMapOpen(false); }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>
                  {dc.btnCats}
                  {catFilter !== "all" && <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--cr-blue)", flexShrink: 0 }} />}
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ transform: catOpen ? "rotate(180deg)" : "none", transition: "transform 0.15s" }}><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                {catOpen && (
                  <div className="dir-map-dropdown" onMouseDown={e => e.stopPropagation()}>
                    <button className={`dir-map-item${catFilter === "all" ? " is-on" : ""}`}
                      onClick={() => { setCatFilter("all"); setCatOpen(false); }}>
                      {dc.allCats}{catFilter === "all" && <span>✓</span>}
                    </button>
                    {activeCats.filter(c => c.id !== 'all').map(c => (
                      <button key={c.id} className={`dir-map-item${catFilter === c.id ? " is-on" : ""}`}
                        onClick={() => { setCatFilter(c.id); setCatOpen(false); }}>
                        <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <img src={`/imagenes/icons/${c.icon}`} style={{ width: 16, height: 16, objectFit: "contain" }} alt="" />
                          {catLabels[c.id] || c.id}
                        </span>
                        {catFilter === c.id && <span>✓</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <input
                className="dir-search"
                type="search"
                placeholder={dc.searchPlaceholder}
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>

            {fetched && !loading && (
              <div className="dir-status">
                {selectedMap !== "all" ? selectedMapLabel : ""}
                {selectedMap !== "all" && catFilter !== "all" ? " · " : ""}
                {catFilter !== "all" ? selectedCatLabel : ""}
                {search ? `${selectedMap !== "all" || catFilter !== "all" ? " · " : ""}"${search}"` : ""}
              </div>
            )}

            <div className="dir-list-wrap" ref={listWrapRef}>
              <div className="dir-list">
                {loading && <div className="dir-loading">{dc.loading}</div>}
                {!loading && fetched && filtered.length === 0 && <div className="dir-loading">{dc.noResults}</div>}
                {filtered.map(h => {
                  const hKey = `${h._mapaId}:${h.id}`;
                  return (
                    <button key={hKey} type="button"
                      className={`dir-card${selKey === hKey ? " is-active" : ""}`}
                      onClick={() => { setSelected(h); setPanelOpen(true); if (window.trackEvent) window.trackEvent({ type: 'popup_open', company: h.name, clientId: h.id || '', mapCode: h._mapaId || '' }); }}>
                      <div className="dir-card-thumb"
                        style={h.hero ? { backgroundImage: `url(${h.hero})`, backgroundSize: "cover", backgroundPosition: "center" } : {}}>
                        {!h.hero && <img src={`/imagenes/icons/${h.icon}`} alt="" />}
                      </div>
                      <div className="dir-card-info">
                        <div className="dir-card-name">{h.name}</div>
                        <div className="dir-card-badge">
                          <img src={`/imagenes/icons/${h.icon}`} alt="" />
                          {catLabels[h._catKey] || h._catKey}
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          {/* DZI map — INDEPENDENT block below the directory block. */}
          {selected && selected.xy && selected._mapaId && (
            <div className="dir-left-map">
              <DirMiniMap mapCode={selected._mapaId} xy={selected.xy} recordId={`L-${selected.id}`} />
            </div>
          )}
          </div>

          <div className="dir-panel" ref={panelRef} style={{ position: "relative" }}>
            {showMore && (
              <div className="dir-scroll-hint" ref={hintRef} aria-hidden="true">
                <div className="dir-scroll-hint-bar" onClick={() => { if (hintRef.current) hintRef.current.style.display = 'none'; setShowMore(false); hintDismissedRef.current = true; panelRef.current.scrollTo({ top: panelRef.current.scrollHeight, behavior: 'smooth' }); }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                </div>
              </div>
            )}
            {!selected ? (
              <div className="dir-panel-empty">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.35"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <span>{dc.emptyHint}</span>
              </div>
            ) : (
              <>
                {selected.hero ? (
                  <div className="dir-panel-hero">
                    <img src={selected.hero} alt={selected.name} />
                  </div>
                ) : (
                  <div className="dir-panel-hero is-placeholder">
                    <img src={`/imagenes/icons/${selected.icon}`} alt="" />
                  </div>
                )}
                <div className="dir-panel-meta">
                  <div className="dir-panel-cat">
                    <img src={`/imagenes/icons/${selected.icon}`} alt="" />
                    {catLabels[selected._catKey] || selected._catKey}
                  </div>
                  <div className="dir-panel-name">{selected.name}</div>
                  {selected._mapaId && (
                    <div className="dir-panel-region">
                      {DIR_REGIONS.find(r => r.id === selected._mapaId)?.label || selected._mapaId}
                    </div>
                  )}
                </div>
                <div className="dir-panel-body">
                  {selected.desc && <div className="dir-panel-desc" dangerouslySetInnerHTML={{ __html: _dirSanitizeDesc(selected.desc) }} />}
                  <div className="dir-panel-actions">
                    {selected.phone && (
                      <a href={`tel:${selected.phone}`} className="dir-action-btn" onClick={() => trackDir('phone')}>
                        <img src="/imagenes/icons/phone-icon.png" alt="" />
                        {dc.actions.call}
                      </a>
                    )}
                    {selected.whatsapp && (
                      <a href={`https://wa.me/${selected.whatsapp.replace(/\D/g,"")}`} target="_blank" rel="noopener" className="dir-action-btn" onClick={() => trackDir('whatsapp')}>
                        <img src="/imagenes/icons/whatsapp-icon.png" alt="" />
                        {dc.actions.whatsapp}
                      </a>
                    )}
                    {selected.website && (
                      <a href={selected.website} target="_blank" rel="noopener" className="dir-action-btn" onClick={() => trackDir('website')}>
                        <img src="/imagenes/icons/web-icon.png" alt="" />
                        {dc.actions.website}
                      </a>
                    )}
                    {selected.gmaps && (
                      <a href={selected.gmaps} target="_blank" rel="noopener" className="dir-action-btn" onClick={() => trackDir('maps')}>
                        <img src="/imagenes/icons/Google-icon.png" alt="" />
                        {dc.actions.maps}
                      </a>
                    )}
                    {selected.waze && (
                      <a href={selected.waze} target="_blank" rel="noopener" className="dir-action-btn" data-kind="waze" onClick={() => trackDir('waze')}>
                        <img src="/imagenes/icons/waze-icon.png" alt="" />
                        {dc.actions.waze}
                      </a>
                    )}
                    {selected.email && (
                      <a href={`mailto:${selected.email}`} className="dir-action-btn" onClick={() => trackDir('email')}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
                        {dc.actions.email}
                      </a>
                    )}
                  </div>
                  {placeUrl && <DirPlaceButton url={placeUrl} copy={dc.place} onOpen={openPlace} />}
                </div>
                {selected.gpsLat && selected.gpsLon && (() => {
                  const lat = selected.gpsLat, lon = selected.gpsLon, d = 0.008;
                  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${lon-d},${lat-d},${lon+d},${lat+d}&layer=mapnik&marker=${lat},${lon}`;
                  return (
                    <>
                      <div className="dir-panel-h">{dc.mapLocation}</div>
                      <div className="dir-panel-map">
                        <iframe key={selected.id} src={src} loading="lazy" title={selected.name} allowFullScreen />
                      </div>
                    </>
                  );
                })()}
              </>
            )}
          </div>
        </div>
      </div>
        {ReactDOM.createPortal(
          <>
            <div className={"dir-mobile-scrim" + (panelOpen && selected ? " is-open" : "")} onClick={() => setPanelOpen(false)} />
            <aside className={"dir-mobile-panel" + (panelOpen && selected ? " is-open" : "")} ref={mobilePanelRef}>
              {selected && (
                <>
                  {selected.hero ? (
                    <div className="dir-panel-hero">
                      <img src={selected.hero} alt={selected.name} />
                      <button className="dir-mobile-back" onClick={() => setPanelOpen(false)} aria-label="Cerrar">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                      </button>
                    </div>
                  ) : (
                    <div className="dir-mobile-noimg-bar">
                      <button className="dir-mobile-back" onClick={() => setPanelOpen(false)} aria-label="Cerrar">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                      </button>
                    </div>
                  )}
                  <div className="dir-panel-meta">
                    <div className="dir-panel-cat">
                      <img src={`/imagenes/icons/${selected.icon}`} alt="" />
                      {catLabels[selected._catKey] || selected._catKey}
                    </div>
                    <div className="dir-panel-name">{selected.name}</div>
                    {selected._mapaId && (
                      <div className="dir-panel-region">
                        {DIR_REGIONS.find(r => r.id === selected._mapaId)?.label || selected._mapaId}
                      </div>
                    )}
                  </div>
                  <div className="dir-panel-body">
                    {selected.desc && <div className="dir-panel-desc" dangerouslySetInnerHTML={{ __html: _dirSanitizeDesc(selected.desc) }} />}
                    <div className="dir-panel-actions">
                      {selected.phone && <a href={`tel:${selected.phone}`} className="dir-action-btn" onClick={() => trackDir('phone')}><img src="/imagenes/icons/phone-icon.png" alt="" />{dc.actions.call}</a>}
                      {selected.whatsapp && <a href={`https://wa.me/${selected.whatsapp.replace(/\D/g,"")}`} target="_blank" rel="noopener" className="dir-action-btn" onClick={() => trackDir('whatsapp')}><img src="/imagenes/icons/whatsapp-icon.png" alt="" />{dc.actions.whatsapp}</a>}
                      {selected.website && <a href={selected.website} target="_blank" rel="noopener" className="dir-action-btn" onClick={() => trackDir('website')}><img src="/imagenes/icons/web-icon.png" alt="" />{dc.actions.website}</a>}
                      {selected.gmaps && <a href={selected.gmaps} target="_blank" rel="noopener" className="dir-action-btn" onClick={() => trackDir('maps')}><img src="/imagenes/icons/Google-icon.png" alt="" />{dc.actions.maps}</a>}
                      {selected.waze && <a href={selected.waze} target="_blank" rel="noopener" className="dir-action-btn" data-kind="waze" onClick={() => trackDir('waze')}><img src="/imagenes/icons/waze-icon.png" alt="" />{dc.actions.waze}</a>}
                      {selected.email && <a href={`mailto:${selected.email}`} className="dir-action-btn" onClick={() => trackDir('email')}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>{dc.actions.email}</a>}
                    </div>
                    {placeUrl && <DirPlaceButton url={placeUrl} copy={dc.place} onOpen={openPlace} />}
                  </div>
                  {/* DZI mini map from the CRMAPS coordinate generator (xy). Replaces the OSM slot. */}
                  {selected.xy && selected._mapaId && (
                    <>
                      <div className="dir-panel-h">MAP LOCATION</div>
                      <div className="dir-panel-map">
                        <DirMiniMap mapCode={selected._mapaId} xy={selected.xy} recordId={`m-${selected.id}`} />
                      </div>
                    </>
                  )}
                  {/* OSM location map — hidden (see _DIR_SHOW_OSM_FALLBACK). Kept, not deleted. */}
                  {_DIR_SHOW_OSM_FALLBACK && selected.gpsLat && selected.gpsLon && (() => {
                    const lat = selected.gpsLat, lon = selected.gpsLon, d = 0.008;
                    const src = `https://www.openstreetmap.org/export/embed.html?bbox=${lon-d},${lat-d},${lon+d},${lat+d}&layer=mapnik&marker=${lat},${lon}`;
                    return (
                      <>
                        <div className="dir-panel-map">
                          <iframe key={`m-${selected.id}`} src={src} loading="lazy" title={selected.name} allowFullScreen />
                        </div>
                      </>
                    );
                  })()}
                </>
              )}
            </aside>
          </>,
          document.body
        )}
    </section>
  );
}

// ============================================================
// MOBILE APP — phone toggle web/mobile
// ============================================================
function MobileSection({ copy }) {
  const [mode, setMode] = React.useState("mobile"); // "mobile" | "web"

  return (
    <section className="section section--hero-blue" id="mobile" data-screen-label="05 Mobile App">
      <div className="section-inner">
        <div className="mobile-showcase">
          <div className="mobile-stage" data-mode={mode}>
            <div className="phone phone--mobile">
              <div className="phone__notch" />
              <div className="phone__screen">
                <div className="phone-screen__topbar">
                  <img className="phone-screen__logo" src="/imagenes/index/logo_2026_header.svg" alt="CRMaps" />
                </div>
                <div className="phone-mapview">
                  <img className="phone-mapview__pin" src="/imagenes/icons/accomodation_icom.png" style={{ left: "30%", top: "32%" }} alt="" />
                  <img className="phone-mapview__pin" src="/imagenes/icons/restaurante_icon.png" style={{ left: "55%", top: "44%" }} alt="" />
                  <img className="phone-mapview__pin" src="/imagenes/icons/beach_icon.png" style={{ left: "44%", top: "62%" }} alt="" />
                  <img className="phone-mapview__pin" src="/imagenes/icons/park_icon.png" style={{ left: "70%", top: "30%" }} alt="" />
                  <img className="phone-mapview__pin" src="/imagenes/icons/general_icon.png" style={{ left: "22%", top: "70%" }} alt="" />
                </div>
                <div className="phone-bottombar">
                  <div className="phone-bottombar__btn is-on"><img src="/imagenes/icons/general_icon.png" alt="" /></div>
                  <div className="phone-bottombar__btn"><img src="/imagenes/icons/beach_icon.png" alt="" /></div>
                  <div className="phone-bottombar__btn"><img src="/imagenes/icons/restaurante_icon.png" alt="" /></div>
                  <div className="phone-bottombar__btn"><img src="/imagenes/icons/info_icon.png" alt="" /></div>
                </div>
              </div>
            </div>
            <div className="phone--web-shadow">
              <div style={{
                width: 460, height: 280, borderRadius: 14,
                background: "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(255,255,255,0.86))",
                border: "1px solid rgba(255,255,255,0.6)",
                boxShadow: "0 30px 60px rgba(0,0,0,0.3)",
                position: "relative", overflow: "hidden"
              }}>
                <div style={{ height: 32, background: "var(--cr-blue)", display: "flex", alignItems: "center", padding: "0 12px", color: "#fff", font: "700 11px/1 Roboto" }}>crmaps.com</div>
                <div style={{ position: "absolute", inset: "32px 0 0", background: "radial-gradient(ellipse 50% 60% at 50% 50%, #6dac6f 0%, transparent 60%), linear-gradient(180deg, #afd8e6 0%, #d4ebe0 100%)" }}>
                  <img src="/imagenes/icons/restaurante_icon.png" style={{ position: "absolute", left: "30%", top: "40%", width: 28, height: 28 }} alt="" />
                  <img src="/imagenes/icons/beach_icon.png" style={{ position: "absolute", left: "55%", top: "55%", width: 28, height: 28 }} alt="" />
                  <img src="/imagenes/icons/accomodation_icom.png" style={{ position: "absolute", left: "70%", top: "35%", width: 28, height: 28 }} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div>
            <span className="kicker kicker--white">{copy.mobile.kicker}</span>
            <h2 className="title">{copy.mobile.titlePrefix} <em>{copy.mobile.titleEm}</em></h2>
            <p className="lede">{copy.mobile.lede}</p>
            <div className="mode-toggle">
              <button className={mode === "mobile" ? "is-on" : ""} onClick={() => setMode("mobile")}>{copy.mobile.modeMobile}</button>
              <button className={mode === "web" ? "is-on" : ""} onClick={() => setMode("web")}>{copy.mobile.modeWeb}</button>
            </div>
            <ul className="feature-list">
              {copy.mobile.features.map((feature) => (
                <li key={feature.strong}><span><strong>{feature.strong}</strong> — {feature.text}</span></li>
              ))}
            </ul>
            <div className="dl-buttons store-buttons--inline">
              <a className="store-btn" href="https://apps.apple.com/cr/app/crmaps/id908064640" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 12.04c-.03-2.86 2.34-4.24 2.45-4.31-1.34-1.95-3.42-2.22-4.16-2.25-1.77-.18-3.46 1.04-4.36 1.04-.91 0-2.29-1.02-3.77-.99-1.94.03-3.74 1.13-4.74 2.86-2.02 3.51-.52 8.7 1.45 11.55.96 1.39 2.1 2.95 3.59 2.9 1.45-.06 2-.94 3.75-.94 1.74 0 2.24.94 3.77.91 1.56-.03 2.55-1.42 3.5-2.82 1.1-1.62 1.56-3.18 1.58-3.26-.04-.02-3.03-1.16-3.06-4.6zM14.6 4.04c.79-.96 1.33-2.29 1.18-3.62-1.14.05-2.53.76-3.35 1.71-.74.85-1.39 2.21-1.21 3.51 1.27.1 2.58-.65 3.38-1.6z" /></svg>
                <div><span>{copy.mobile.appStorePrefix}</span><strong>{copy.mobile.appStore}</strong></div>
              </a>
              <a className="store-btn" href="https://play.google.com/store/search?q=crmaps&c=apps" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 512 512" aria-hidden="true">
                  <path fill="#00A0FF" d="M93.4 39.9c-8.2 5.1-13.4 14.3-13.4 26.2v379.8c0 11.9 5.2 21.1 13.5 26.2L304.6 256 93.4 39.9z" />
                  <path fill="#00F076" d="M304.6 256 93.5 472.1c8.3 5.1 19.5 5.1 31.6-1.8l250.7-142.4L304.6 256z" />
                  <path fill="#FFEA00" d="M375.8 184.1 125.1 41.7c-12.1-6.9-23.4-6.9-31.7-1.8L304.6 256l71.2-71.9z" />
                  <path fill="#FF3D00" d="m429.7 214.7-53.9-30.6L304.6 256l71.2 71.9 53.9-30.6c29.8-16.9 29.8-65.7 0-82.6z" />
                </svg>
                <div><span>{copy.mobile.googlePrefix}</span><strong>{copy.mobile.googlePlay}</strong></div>
              </a>
            </div>
            <div className="qr-card">
              <div className="qr-card__code">
                <img src="/imagenes/index/qr_crmaps_app.png" alt="QR CRMaps app" />
              </div>
              <div>
                <strong>{copy.mobile.qrTitle}</strong>
                <span>{copy.mobile.qrText}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

window.DirectorySection = DirectorySection;
window.MobileSection = MobileSection;
})();

  